import { render, staticRenderFns } from "./ODTs.vue?vue&type=template&id=45b35250&scoped=true&"
import script from "./ODTs.vue?vue&type=script&lang=js&"
export * from "./ODTs.vue?vue&type=script&lang=js&"
import style0 from "./ODTs.vue?vue&type=style&index=0&id=45b35250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b35250",
  null
  
)

export default component.exports